<template>
<div>
  <NavBar v-if="!standaloneToolRoute"/>
  <SeoBreadcrumbs/>
  <router-view/>
  <AppDevelopmentCta v-if="$route.name !== 'not-found'"/>
  <Footer2/>
  <div class="modal-pop" :style="{
    'display' : show== 'yes'? 'flex' : 'none',
  }" style="z-index: 11111;position: fixed;top: 0;left: 0;justify-content: center;align-items: center;width: 100vw;height: 100vh;">
    <div class="modal-pop-body" :style="{
      'flex-direction': currentLanguage == 'ar' ? 'row' : 'row-reverse',
    }" style="width: 50%;height: 70vh;z-index: 3;position: relative;display: flex;    width: 850px;max-width: 95%;border-radius: 10px;box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);">
      <div class="close-btn" @click="closePopup">×</div>
      <div class="left" :class="currentLanguage == 'ar' ? 'ar' : 'en'" style="flex: 1;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;border-top-right-radius: 10px; border-bottom-right-radius: 10px;">
        <img style="max-width: 100%;
    height: auto;
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));" src="./assets/SplendApp_popup.png" alt="">
      </div>
      <div :style="currentLanguage == 'ar' ? 'direction: rtl' : ''" class="right" :class="currentLanguage == 'ar' ? 'ar' : 'en'" style="    flex: 1.1;
    background-color: #3a7aff;
    padding: 60px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;border-top-left-radius: 10px; border-bottom-left-radius: 10px;">
        <p style="font-size: 14px;font-weight: 600;margin-bottom: 15px;opacity: 0.9;">{{ formdata[currentLanguage].att }}</p>
        <h3 style="font-size: 52px;font-weight: 700;line-height: 1.2;margin-bottom: 20px;">{{ formdata[currentLanguage].title }}</h3>
        <p :style="currentLanguage == 'ar' ? 'direction: rtl' : ''" style="font-size: 18px;line-height: 1.6;margin-bottom: 40px;opacity: 0.9;">{{ formdata[currentLanguage].desc }}</p>
        <a :style="currentLanguage == 'ar' ? 'direction: rtl' : ''" :href="formdata[currentLanguage].url" @click="trackPopupClick" style="    color: #fff;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: left;
    border-bottom: 2px solid #fff;
    padding-bottom: 5px;
    width: fit-content;
    transition: 0.3s;">{{ formdata[currentLanguage].button }}</a>
      </div>
    </div>
    <div class="modal-pop-overlay" style="width: 100vw;height: 100vh;background-color:#000000b8;z-index: 1;position: absolute;top: 0;left: 0;">

    </div>
  </div>
</div>
</template>

<script>
import 'bootstrap';
import NavBar from '@/components/NavBar.vue'
import Footer2 from '@/components/Footer2.vue'
import SeoBreadcrumbs from '@/components/SeoBreadcrumbs.vue'
import AppDevelopmentCta from '@/components/AppDevelopmentCta.vue'
import { trackPromotionClick } from '@/utils/promotionAnalytics'
import {
  PROMO_POPUP_DELAY_MS,
  PROMO_POPUP_EVENT,
  canShowPromoPopup,
  recordPromoPopupImpression
} from '@/utils/promoPopup'
export default {
  data() {
    return {
      currentLanguage: 'ar',
      show: 'no',
      popupTimer: null,
      popupTrigger: null,
      formdata: {
        ar: {
          title: 'موقعك وحده لا يكفي؟',
          desc: 'تطبيقات الجوال تزيد مبيعاتك بنسبة 160%.',
          button: 'ابدأ تطبيقك مع سبلينداب ←',
          att: 'نصيحة نمو',
          url : 'https://splendapp.com'
        },
        en: {
          title: 'Is Your Website Enough?',
          desc: 'Mobile Apps drive 2x more sales than websites.',
          button: 'Build with SplendApp →',
          att: 'Growth Tip',
          url : 'https://splendapp.com/en/'
        }
      }
    }
  },
  components: {
    NavBar,
    Footer2,
    SeoBreadcrumbs,
    AppDevelopmentCta
  },
  watch: {
    $route() {
      this.syncPopupLanguage();
    }
  },
  computed: {
    standaloneToolRoute() {
      return ['booking-loss-calculator-ar', 'booking-loss-calculator-en', 'app-roi-calculator-ar', 'app-roi-calculator-en'].includes(this.$route.name)
    }
  },
  mounted() {
    this.syncPopupLanguage();
    window.addEventListener(PROMO_POPUP_EVENT, this.handleToolSuccess);
    this.schedulePopup();
  },
  beforeDestroy() {
    this.cancelPopupTimer();
    window.removeEventListener(PROMO_POPUP_EVENT, this.handleToolSuccess);
  },
  methods: {
  syncPopupLanguage() {
    if (this.$store.state.currentLanguage == 'en') {
      this.currentLanguage = 'en';
    } else if (this.$store.state.currentLanguage == 'ar') {
      this.currentLanguage = 'ar';
    }

  },

  schedulePopup() {
    this.cancelPopupTimer();
    if (!canShowPromoPopup()) return;

    this.popupTimer = window.setTimeout(() => {
      this.openPopup('timeout');
    }, PROMO_POPUP_DELAY_MS);
  },

  cancelPopupTimer() {
    if (this.popupTimer !== null) {
      window.clearTimeout(this.popupTimer);
      this.popupTimer = null;
    }
  },

  handleToolSuccess() {
    this.openPopup('tool_success');
  },

  openPopup(trigger) {
    this.cancelPopupTimer();
    if (!canShowPromoPopup()) return;

    this.syncPopupLanguage();
    recordPromoPopupImpression();
    this.show = 'yes';
    this.popupTrigger = trigger;
  },

  closePopup() {
    this.show = 'no';
    this.cancelPopupTimer();
  },

  trackPopupClick() {
    trackPromotionClick(this.$gtag, 'app_development_popup', {
      language: this.currentLanguage,
      popup_trigger: this.popupTrigger || 'unknown',
      source_route: this.$route.name || 'unknown'
    });
    this.closePopup();
  }
}
}
</script>
<style lang="scss">
:root{
  --main-color: #24365c;
  --page-surface: #f6f9fb;
}
html, body, #app { width: 100%; max-width: 100%; overflow-x: hidden; }
*, *::before, *::after { box-sizing: border-box; }
#app {
  font-family: 'Cairo', sans-serif;
  background: var(--page-surface);
}
body{
  margin: 0;
  padding: 0;
  background: var(--page-surface);
  font-family: 'Cairo', sans-serif;
}
/*@media (max-width: 700px) {
  .modal-pop-body{
    flex-direction: column-reverse !important;
    width: 90% !important;
    height: 91% !important;
  }
  .modal-pop-body > div.left{
    width: 100% !important;
    height: 40% !important;
  } 
  .modal-pop-body > div.right{
    width: 100% !important;
    height: 60% !important;
  } 
  .modal-pop-body > div:nth-of-type(3){
    padding: 70px 20px 20px !important;
  }
  .modal-pop-body > div:nth-of-type(3) a{
    margin-bottom: 20px !important;
  }
  .modal-pop-body > div:nth-of-type(3) img{
    margin-bottom: 30px !important;
  }
}*/
.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    z-index: 10;
    background: rgba(0, 0, 0, 0.1);
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: 0.3s;
    padding-bottom: 4px;
}
.right.ar{
  border-radius: 0 10px 10px 0 !important;
}
.left.ar{
  border-radius: 10px 0px 0px 10px !important;
}
@media (max-width: 768px) {
            .modal-pop-body {
                flex-direction: column-reverse !important;
                width: 90% !important;
                height: unset !important;
            }
            .right {
                padding: 40px 30px !important;
                text-align: center !important;
                align-items: center !important;
                border-radius: 10px 10px 0 0 !important;
            }
            .headline {
                font-size: 32px !important;
            }
            .left {
                padding: 20px !important;
                border-radius: 0px 0px 10px 10px !important;
            }
            .right.ar{
              border-radius: 10px 10px 0 0 !important;
            }
            .left.ar{
              border-radius: 0px 0px 10px 10px !important;
            }
            .close-btn {
                color: #333; /* تغيير لون الزر ليظهر على الخلفية البيضاء في الجوال */
            }
        }
        .tui-image-editor-container.left{
          padding: 0 !important;
        }
@import url('./assets/styles/bootstrap.min.css');
@import url('./assets/styles/all.min.css');
</style>
